import MasterCrudPage from "../../components/MasterCrudPage";
import { mediaTypeApi } from "../../api/masterApi";

export default function MediaTypeMaster() {
  return (
    <MasterCrudPage
      title="Media Type Master"
      description="Media types such as TV, Print, Digital."
      idKey="media_type_id"
      api={mediaTypeApi}
      listLabel="media types"
      useJson
      fields={[
        {
          name: "media_type_name",
          label: "Media Type",
          type: "text",
          required: true,
          fullWidth: true,
          placeholder: "e.g. TV, Print, Digital",
        },
      ]}
      columns={[
        { key: "media_type_id", label: "Media Type" },
        { key: "media_type_name", label: "Media Type" },
      ]}
    />
  );
}
